import jwtDecode, { JwtPayload } from "jwt-decode";

interface ExtendedJwtPayload extends JwtPayload {
  customerId?: string;
}

export const getUserIdFromToken = (token: string) => {
  try {
    const decodedToken: JwtPayload = jwtDecode<JwtPayload>(token);
    if (decodedToken.sub) {
      return decodedToken.sub;
    }
  } catch {
    throw new Error("JWT token authentication error");
  }
};

export const getCustomerIdFromToken = (token: string) => {
  try {
    const decodedToken: ExtendedJwtPayload =
      jwtDecode<ExtendedJwtPayload>(token);
    if (decodedToken.customerId) {
      return decodedToken.customerId;
    }
  } catch {
    throw new Error("JWT token authentication error");
  }
};
